{
  "actionSelectLabel": "Acción",
  "createScheduleHelpContent": "Quick Scheduler es una función que le permite crear un cronograma para activar una bomba o válvula en un momento específico o durante un período específico.\n\nLos cronogramas se pueden configurar para que se ejecuten una sola vez o para que se repitan en días específicos de la semana. Para programar una sola ejecución, seleccione \"Hacer una vez\"; de lo contrario, seleccione \"Repetir\".\n\nTenga en cuenta que esta función está diseñada para usarse con bombas y válvulas que FarmHQ pueda activar. El uso de esta función con bombas que solo se apagan u otros tipos de equipos puede tener consecuencias no deseadas.",
  "createScheduleHelpTitle": "Acerca de Quick Scheduler",
  "dayPickerLabel": "Día",
  "delayedShutdownTitle": "Apagado retrasado",
  "deviceSelectLabel": "Dispositivo",
  "deviceSelectPlaceholder": "(Seleccionar dispositivo)",
  "durationHoursLabel": "Horas",
  "durationMinutesLabel": "Minutos",
  "errorMessages": {
    "DURATION_BELOW_MINIMUM": "La duración debe ser mayor a 0 minutos.",
    "EXECUTION_TIME_IN_PAST": "El tiempo de ejecución no puede ser del pasado.",
    "NO_COMPATIBLE_DEVICES": "No se encontraron dispositivos compatibles,",
    "NO_REPEATING_DAYS": "El horario debe repetirse al menos un día.",
    "SCHEDULE_END_BEFORE_START": "El final del horario es antes del inicio.",
    "SCHEDULE_END_IN_PAST": "El final del cronograma no puede ser en el pasado.",
    "SCHEDULE_START_IN_PAST": "El inicio del cronograma no puede ser en el pasado.",
    "SHUTDOWN_IN_PAST": "El cierre debe ser en el futuro"
  },
  "executeAt": "Ejecutar en",
  "executeAtWithTimezone": "Ejecutar en ({{timezone}})",
  "executionDay": "Día de ejecución",
  "frequencyLabel": "Frecuencia",
  "linkToCreateSchedule": "Nuevo horario",
  "linkToDelayedShutdown": "Apagado retrasado",
  "next": "Próximo",
  "nextDay": "Al día siguiente",
  "back": "Atrás",
  "cancel": "Cancelar",
  "noCompatibleDevices": "No se encontraron dispositivos compatibles,",
  "quickSchedulerTitle": "Programador rápido",
  "repeatOnDays": "Repetir en días",
  "scheduleEndLabel": "Fin del horario",
  "scheduleFrequencyTypes": {
    "doOnce": "Hazlo una vez",
    "repeat": "Repetir"
  },
  "schedulePumpingSession": "Programar una sesión de extracción de leche",
  "scheduleStartLabel": "Horario de inicio",
  "shutdownPumpAt": "Apagado de la bomba en",
  "submit": "Entregar",
  "timePickerLabel": "Tiempo",
  "turnOfThePumpForWithVal": "Apague la bomba durante {{val}}",
  "turnOffThePumpAfter": "Apague la bomba después",
  "turnOnThePumpAt": "Encienda la bomba en",
  "turnOnThePumpAtWithTimezone": "Encienda la bomba a las ({{timezone}})",
  "usageWarning": "Esta función está diseñada para usarse con bombas y válvulas que FarmHQ pueda activar. El uso de esta función con bombas que solo se apagan u otros tipos de equipos puede tener consecuencias no deseadas."
}
